class GltheaaHeader extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onSearchToggle = this.onSearchToggle.bind(this);
    this.onSearchClose = this.onSearchClose.bind(this);
    this.onDrawerOpen = this.onDrawerOpen.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.gltheaa-header-wrapper');
    this.section = this.closest('.gltheaa-header-section');
    this.search = this.querySelector('.gltheaa-header-search');
    this.searchToggles = this.querySelectorAll('[data-gltheaa-search-toggle]');
    this.searchClose = this.querySelector('[data-gltheaa-search-close]');
    this.drawer = this.querySelector('gltheaa-header-drawer');
    this.drawerOpenButtons = this.querySelectorAll('[data-gltheaa-drawer-open]');
    this.drawerClose = this.querySelectorAll('[data-gltheaa-drawer-close]');
    this.onResize = this.setHeaderHeight.bind(this);

    if (this.dataset.sticky !== 'false') {
      document.body.classList.add('gltheaa-header-is-fixed');
      this.section?.classList.add('gltheaa-header-section--fixed');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    this.setHeaderHeight();
    window.addEventListener('resize', this.onResize);

    this.searchToggles.forEach((button) => button.addEventListener('click', this.onSearchToggle));
    this.searchClose?.addEventListener('click', this.onSearchClose);
    this.drawerOpenButtons.forEach((button) => button.addEventListener('click', this.onDrawerOpen));
    this.drawerClose.forEach((button) => button.addEventListener('click', this.onDrawerClose));
    document.addEventListener('keydown', this.onKeydown);

    this.bindCartDrawer();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove('gltheaa-header-is-fixed');
    this.searchToggles?.forEach((button) => button.removeEventListener('click', this.onSearchToggle));
    this.searchClose?.removeEventListener('click', this.onSearchClose);
    this.drawerOpenButtons?.forEach((button) => button.removeEventListener('click', this.onDrawerOpen));
    this.drawerClose?.forEach((button) => button.removeEventListener('click', this.onDrawerClose));
    document.removeEventListener('keydown', this.onKeydown);
  }

  setHeaderHeight() {
    if (!this.section) return;

    const headerHeight = this.section.offsetHeight;

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

    const main = document.getElementById('MainContent');
    if (!main) return;

    if (this.dataset.overlay === 'true') {
      main.style.paddingTop = '';
    } else {
      main.style.paddingTop = `${headerHeight}px`;
    }

    this.onScroll();
  }

  onScroll() {
    const announcementBar = document.querySelector(
      '.shopify-section-group-header-group.gltheaa-announcement-bar-section'
    );
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const scrollY = window.scrollY;
    const headerTop = Math.max(0, announcementHeight - scrollY);

    document.documentElement.style.setProperty('--gltheaa-header-top', `${headerTop}px`);

    const scrolled = scrollY > 10;
    this.wrapper?.classList.toggle('is-scrolled', scrolled);
    this.section?.classList.toggle('scrolled-past-header', scrolled);
  }

  onSearchToggle(event) {
    event.preventDefault();
    this.drawer?.close();
    this.search?.classList.add('is-open');
    this.setSearchExpanded(true);
    this.search?.querySelector('input')?.focus();
  }

  bindCartDrawer() {
    if (this.dataset.cartType !== 'drawer') return;

    const cartDrawer = document.querySelector('cart-drawer');
    const cartLink = this.querySelector('#cart-icon-bubble');
    if (!cartDrawer || !cartLink || cartLink.dataset.cartDrawerBound === 'true') return;

    cartLink.dataset.cartDrawerBound = 'true';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      cartDrawer.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        cartDrawer.open(cartLink);
      }
    });
  }

  onSearchClose(event) {
    event.preventDefault();
    this.closeSearch();
  }

  closeSearch() {
    this.search?.classList.remove('is-open');
    this.setSearchExpanded(false);
  }

  setSearchExpanded(expanded) {
    this.searchToggles?.forEach((button) => {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  onDrawerOpen(event) {
    event.preventDefault();
    if (this.drawer?.classList.contains('active')) {
      this.drawer.close();
      return;
    }
    this.closeSearch();
    this.drawer?.open();
  }

  onDrawerClose(event) {
    event.preventDefault();
    this.drawer?.close();
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    this.drawer?.close();
    this.closeSearch();
  }
}

class GltheaaHeaderDrawer extends HTMLElement {
  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    this.syncTriggers(true);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.syncTriggers(false);
  }

  syncTriggers(expanded) {
    const header = this.closest('gltheaa-header');
    header?.querySelectorAll('[data-gltheaa-drawer-open]').forEach((button) => {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
}

customElements.define('gltheaa-header', GltheaaHeader);
customElements.define('gltheaa-header-drawer', GltheaaHeaderDrawer);
